module.exports = __webpack_public_path__ + "prod/1.42.2/img/vip-icon.9f05d7c4.png";